export default __webpack_public_path__ + "static/media/Live.4f1283d3.svg";